import  { useEffect, useState } from 'react';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import  Header  from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import MemberRegistrationSection from '../../components/sections/memberRegistration';
import { ToastContainer, toast } from 'react-toastify';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';

function MemberRegister() {
      const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);
    return (
        <>
            <div className="antialiased light-vz circle-v ">
                <Header events={events} />
               <br></br>
                <MemberRegistrationSection />
                <MainWebFooter  />
                <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
                <ToastContainer position="bottom-right"/>
            </div>
        </>
    );
}

export default MemberRegister;